const RentalFileStatusConstant = {
  CREATED: 'CREATED',
  CONTRACT_SENT: 'CONTRACT_SENT',
  PACKET_PREPARATION: 'PACKET_PREPARATION',
  TRANSPORT_GO: 'TRANSPORT_GO',
  CLIENT_RECEIPT: 'CLIENT_RECEIPT',
  CLIENT_INFORMED: 'CLIENT_INFORMED',
  STORE_RECEIPT: 'STORE_RECEIPT',
  TRANSPORT_BACK: 'TRANSPORT_BACK',
  BOOMERANG_RECEIPT: 'BOOMERANG_RECEIPT',
  BILLING: 'BILLING',
  CLOSED: 'CLOSED'
}

export default RentalFileStatusConstant
